const { getElements, getElement } = window.BAO.Utils

export class Multipack extends window.BAO.CustomElement() {
  constructor (isInitialLoad = true) {
    super()

    this.multipackProperties = getElement('[data-multipack-item-properties]')

    this.handleMultipack(isInitialLoad)
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('variantChange', this.handleMultipack.bind(this))
  }

  handleMultipack (isInitialLoad = false) {
    const multipackVariants = getElements('[data-multipack-variant]')

    if (multipackVariants.length === 0) return

    const variants = []

    multipackVariants.forEach((variant) => {
      const variantValue = variant.dataset.multipackVariant

      const radioParent = variant.closest('variant-radios')

      if (!radioParent) return

      const data = JSON.parse(getElement("[data-variant-radios-el='data']", { context: radioParent })?.textContent)
      const foundValue = data.filter(variant => variant.option1 === variantValue)

      if (foundValue) {
        variants.push(foundValue)
      }
    })

    const variantsFlatten = variants.flat()

    this.multipackProperties.value = variantsFlatten.map(variant => variant.id)

    if (isInitialLoad !== true) {
      this.handleMultipackAvailability(variantsFlatten)
    }
  }

  handleMultipackAvailability (variantsFlatten) {
    const multipackVariantsNotAllAvailable = !!variantsFlatten.find(
      variant => !variant.available,
    )
    const productForm = getElement('bao-product-form', { context: this.closest('[data-product-multipack]') })
    if (!productForm) return

    const addToCartButton = getElement('[data-product-add-to-cart]', { context: productForm })
    if (!addToCartButton) return

    const addToCartButtonText = getElement('[data-product-add-to-cart-text]', { context: addToCartButton })
    if (!addToCartButtonText) return

    addToCartButton.disabled = multipackVariantsNotAllAvailable
    addToCartButtonText.innerText = multipackVariantsNotAllAvailable ? window.theme.strings.soldOut : window.theme.strings.addToCart
  }
}

if (!customElements.get('multi-pack')) {
  customElements.define('multi-pack', Multipack)
}
